import { render, staticRenderFns } from "./AvisoCulturaNaoSelecionada.vue?vue&type=template&id=368a8126&scoped=true&lang=pug"
import script from "./AvisoCulturaNaoSelecionada.vue?vue&type=script&lang=js"
export * from "./AvisoCulturaNaoSelecionada.vue?vue&type=script&lang=js"
import style0 from "./AvisoCulturaNaoSelecionada.vue?vue&type=style&index=0&id=368a8126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a8126",
  null
  
)

export default component.exports